<div class="wrapper flex flex-col justify-between" data-testid="risk-form">
  <div class="heading-row flex justify-between items-center mb-[24px]">
    <div class="heading text-type-2 truncate">{{ title }}</div>
  </div>
  <form [formGroup]="form" class="details flex-1">
    <app-text-area [parentFormGroup]="form" controlName="description" label="Risk description" [maxLength]="4000" class="block w-full mb-[20px]" />
    <app-text-area [parentFormGroup]="form" controlName="project_impact" label="Project impact" [maxLength]="4000" class="block w-full mb-[20px]" />
    <!-- Stacked: the compact 1–5 picker doesn't fit a half-width column. -->
    <div class="label">Probability:</div>
    <app-toggle-buttons [parentFormGroup]="form" controlName="probability" [buttonLabels]="levels" [compact]="true" testIdPrefix="form-prob-" (valueChange)="form.markAsDirty()" class="block mb-[20px]" />
    <div class="label">Impact:</div>
    <app-toggle-buttons [parentFormGroup]="form" controlName="impact" [buttonLabels]="levels" [compact]="true" testIdPrefix="form-impact-" (valueChange)="form.markAsDirty()" class="block mb-[20px]" />
    @if (score) {
      <div class="score-line flex flex-row items-center gap-[8px] mb-[20px]" data-testid="form-score">
        <app-risk-score-chip [score]="score" /><span class="text-type-14">{{ bandLabel }}</span>
      </div>
    }
    <div class="label pill-label">Risk areas:</div>
    <div class="pills mb-[20px]" data-testid="form-areas">
      @for (a of config.risk_areas; track a) {
        <button type="button" class="pill" [class.on]="hasArea(a)" (click)="toggleArea(a)" [attr.aria-pressed]="hasArea(a)">{{ a }}</button>
      }
    </div>
    <div class="two">
      <app-dropdown [parentFormGroup]="form" controlName="discipline" [options]="disciplineOptions" [enableClearSelection]="true" [panelWidth]="280" label="Discipline" class="block w-full mb-[20px]" />
      <app-dropdown [parentFormGroup]="form" controlName="owner_account_id" [options]="memberOptions" [enableSearch]="true" [enableClearSelection]="true" [panelWidth]="280" [label]="ownerLabel" class="block w-full mb-[20px]" />
    </div>
    <app-dropdown [parentFormGroup]="form" controlName="response_type" [options]="responseTypes" [enableClearSelection]="true" label="Response type" class="block w-full mb-[20px]" />
    <app-text-area [parentFormGroup]="form" controlName="response_strategy" label="Response strategy" [maxLength]="4000" class="block w-full mb-[20px]" />
    <app-text-area [parentFormGroup]="form" controlName="response_action" label="Action to implement" [maxLength]="4000" class="block w-full mb-[20px]" />
    <app-date-picker [parentFormGroup]="form" controlName="identified_at" label="Date identified" class="block w-full mb-[20px]" />
    <app-pictures-section-with-tags
      (onDelete)="removeFile($event)"
      [add]="true"
      [pictures]="files"
      [tags]="attachmentTag"
      [allowVideo]="false"
      [accept]="attachmentAccept"
      class="pictures-section block mb-[20px]"
      label="Attachments:"
      data-testid="form-attach"
    />
    @if (showInternal) {
      <div class="flex flex-row items-center justify-between gap-[12px] mb-[20px]">
        <div class="label !mb-0">Internal (hidden from contractors):</div>
        <mat-slide-toggle formControlName="internal" color="primary" data-testid="form-internal"></mat-slide-toggle>
      </div>
    }
  </form>
  <div class="action-section flex flex-row gap-[16px] w-full">
    <app-secondary-button (handleClick)="cancel()" class="flex-1" data-testid="form-cancel">Cancel</app-secondary-button>
    <app-primary-button (handleClick)="submit()" [isDisabled]="submitDisabled" [isLoading]="saving" class="flex-1" data-testid="form-submit">{{ submitLabel }}</app-primary-button>
  </div>
</div>
